module.exports = __webpack_public_path__ + "04_glasses_brown.abfc8cdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer4/04_glasses_brown.png
// module id = +a9K
// module chunks = 0